// extracted by mini-css-extract-plugin
export default {"add-to-calendar":"AddToCalendar_add-to-calendar__J204v"};